export class BaseModel {
  id?: string;
  facilityId: string;
}
